import React from 'react';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Consistent section title strip.
 * eyebrow = small uppercase label, title = h2, optional description + action slot.
 */
export default function SectionHeader({
  eyebrow,
  title,
  description,
  actions,
  className = '',
}: SectionHeaderProps) {
  return (
    <div className={`flex items-start justify-between gap-4 mb-4 ${className}`.trim()}>
      <div className="min-w-0">
        {eyebrow ? <div className="text-eyebrow">{eyebrow}</div> : null}
        <h2 className="text-h2 mt-1">{title}</h2>
        {description ? <p className="text-muted text-sm mt-1">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
    </div>
  );
}
